// Доступ к конфигу приложения с приоритетом «рантайм → build → fallback».
//   1) window.__APP_CONFIG__[name] — рантайм-конфиг (вариант 3): генерится энтрипоинтом
//      контейнера в app-config.<hash>.js из смонтированного .env стенда.
//      См. docs/runtime-config.md.
//   2) build-значение из .env, зашитое webpack'ом на сборку (используется локально под
//      `vue serve`; на стендах образ собирается без env → тут undefined).
//   3) переданный fallback.
//
// ВАЖНО про webpack: инлайнится ТОЛЬКО статический доступ `process.env.VUE_APP_X`
// (литеральное обращение). Динамический `process.env[name]` НЕ инлайнится и в браузере
// упадёт (`process` не определён). Поэтому build-значения перечисляем СТАТИЧЕСКОЙ картой —
// новый VUE_APP_*-параметр добавляется сюда одной строкой.
const BUILD_ENV = {
  VUE_APP_API_URL: process.env.VUE_APP_API_URL,
  VUE_APP_I18N_LOCALE: process.env.VUE_APP_I18N_LOCALE,
  VUE_APP_I18N_FALLBACK_LOCALE: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
};

function firstNonEmpty(...values) {
  for (const v of values) {
    if (v != null && v !== "") return v;
  }
  return undefined;
}

export function appConfig(name, fallback) {
  const runtime = (typeof window !== "undefined" && window.__APP_CONFIG__) || {};
  const value = firstNonEmpty(runtime[name], BUILD_ENV[name]);
  return value !== undefined ? value : fallback;
}
